import React, { useEffect, useState, useRef } from "react"; import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import './style.css'
import { ReactComponent as Icon } from "./Icon.svg"
import { useHistory } from "react-router-dom";
import { putUser } from "api/UsersApi"
import { useSelector } from "react-redux";
let mouseOverStepGuide = false
const axios = require("axios");

const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};


function Guide(props) {
    const history = useHistory();
    const [step, setStep] = useState(0);

    const [skipGuide, setSkipGuide] = useState(false);
    const { userId } = useSelector((state) => state.userSetter)
    const [GuideOn, setGuideOn] = useState(false);
    const [stepTopLocation, setStepTopLocation] = useState(20)
    const [stepLeftLocation, setStepLeftLocation] = useState(20)
    const [steps, setSteps] = useState([])
    const ref = useRef(null);

    let dragging = false;
    let intialX = 0;
    let intialY = 0;

    let locTop = 20;
    let locLeft = 20;
    let newTop = 20;
    let newLeft = 20;



    function setMouseOverStep(state) {
        mouseOverStepGuide = state;
    }

    function navigateToUrl(url) {
        history.push(url);
    }

    useEffect(() => {
        window.addEventListener('mousedown', (e) => {
            if (mouseOverStepGuide) {
                intialX = e.clientX
                intialY = e.clientY

                dragging = true
            }

        })
        let x = 0;
        window.addEventListener('mousemove', (e) => {
            if (dragging) {
                let currDiffX = e.clientX - intialX;
                let currDiffY = e.clientY - intialY;
                newTop = locTop + currDiffY
                newLeft = locLeft - currDiffX
                setStepTopLocation(newTop)
                setStepLeftLocation(newLeft)
                x++

            }

        })
        window.addEventListener('mouseup', (e) => {

            if (dragging) {
                locTop = newTop
                locLeft = newLeft
                dragging = false
            }

        })

        var stepsCopy = [];

        function checkStep() {
            let no = localStorage.getItem('userGuideStep')
            let skip = localStorage.getItem('SkipGuide')
            skip == 'true' ? setSkipGuide(true) : setSkipGuide(false)
            setStep(Number(no))
            if (stepsCopy[no - 1] && skip !== 'true') {
                stepsCopy[no - 1].action()
            }
        }

        window.addEventListener('storage', checkStep)

        axios.get(
            process.env.REACT_APP_API_BASE_URL + `company/onboardingTour`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
            }
        ).then(res => {
            let data = res.data

            data = data.sort((a, b) => a.stepNo - b.stepNo);

            data = data.map(obj => {
                let step = {
                    docURL: obj.docLink,
                    title: obj.title,
                    body: obj.description,
                    action: () => { navigateToUrl(obj.uiMenu) }
                }
                return step;
            })
            stepsCopy = data
            setSteps(data);
            checkStep()
            const stepNumber = localStorage.getItem('userGuideStep')
            const skip = localStorage.getItem('SkipGuide')
            if (skip !== 'true') {
                if (data[stepNumber - 1]) {
                    data[stepNumber - 1].action()
                }
            }

        })

    }, [])

    useEffect(() => {
        const skipGuide = localStorage.getItem('SkipGuide')
        const stepNumber = localStorage.getItem('userGuideStep')
        if (skipGuide == 'true') {
            setSkipGuide(true)
        } else {
            setSkipGuide(false)
            setStep(Number(stepNumber))
        }
    }, [])

    function changeStep(step) {
        localStorage.setItem('userGuideStep', step)
        window.dispatchEvent(new Event('storage'))
        if (step <= steps.length) {
            let act = steps[step - 1].action
            act()
        }

    }



    return (<div ref={ref} className="ug" onMouseEnter={() => setMouseOverStep(true)} onMouseLeave={() => setMouseOverStep(false)}>
        {(!skipGuide && step > 0 && step - 1 < steps.length) && <div className="ug-step" style={{ top: `${stepTopLocation}px`, right: `${stepLeftLocation}px` }}
        >
            {/* <div className="ug-anchor"></div> */}
            <div style={{ display: 'flex', fontSize: '17px',fontWeight: '800' }}>
                <div className='ug-step-title mr-2'>{steps[step - 1].title}</div>
                <div className='ug-step-no'>({step}/{steps.length})</div>
            </div>
            <div dangerouslySetInnerHTML={{ __html: steps[step - 1].body }} className='ug-step-body'></div>
            <div> <a onMouseDown={e => { e.stopPropagation(); }} target='_blank' className='ug-link' href={steps[step - 1].docURL} >Learn More</a> </div>
            <div className='ug-step-footer my-2 mt-4'>

                <input type='button' value="Skip the tour" className='ug-skip' onClick={(e) => {
                    e.stopPropagation();
                    setSkipGuide(true)
                    localStorage.setItem('SkipGuide', true);
                    putUser(userId, { guideSkipped: true })
                    // window.dispatchEvent(new Event('storage'));
                }} />

                <input type='button' value={step == steps.length ? "Finish" : "Next"} className='ug-next' onClick={(e) => {
                    e.stopPropagation();
                    changeStep(step + 1)
                    putUser(userId, { guideStep: step + 1 })

                }} />

            </div>

        </div>}

        {(!skipGuide && step == 0) && <div className="ug-cover">
            <div className="ug-welcome fadeIn">
                <span className="my-3"><Icon /></span>
                <div className="ug-title mb-2">
                    Congratulations, you are all set to start.
                </div>
                <div className="ug-subtitle my-3">
                    This tour will guide you to get started with Kapitalwise. This tour will help you:
                </div>
                <div className="ug-subtitle my-1">
                    1. To set up your Kapitalwise account.
                </div>
                <div className="ug-subtitle my-1">
                    2. Learn more about the Kapitalwise features.
                </div>
                <input
                    type="button"
                    name="Let's start"
                    style={{ cursor: "pointer" }}
                    className="lg_btn primary mt-4 mb-2"
                    id="start"
                    value="Let's start"
                    onClick={() => changeStep(1)}
                />
                <a href='#' onClick={() => {
                    setSkipGuide(true)
                    localStorage.setItem('SkipGuide', true);
                    putUser(userId, { guideSkipped: true })
                }}>Skip</a>
            </div>


        </div>}

    </div>
    );
}
export default Guide;
